import { Component } from "react";
import { Flex, IconButton, Text } from "@radix-ui/themes";
import FontAwesome from "../../../utilities/FontAwesome";
import { observer } from "mobx-react";
import classNames from "classnames";
import styles from "./styles/LocationBlockItem.module.scss";
import { StoreContext } from "../../../../stores/StoreContext";
import dynamic from "next/dynamic";
import ImageComponent from "../../../utilities/ImageComponent";
import ClickableLink from "../../../utilities/ClickableLink";

const PhoneNumber = dynamic(() => import("../../../utilities/PhoneNumber"));

interface ILocationBlockItemProps {
  location: {
    address?: string;
    address2?: string;
    city?: string;
    state?: string;
    zip?: string | number;
    phone?: string | number;
    hours?: any;
    organization?: any;
  };
  onClick?: () => void;
  className?: string;
  attribution?: string;
}

@observer
class LocationBlockItem extends Component<ILocationBlockItemProps> {
  static contextType = StoreContext;
  declare context: React.ContextType<typeof StoreContext>;

  render() {
    const mapInsertClassName = classNames({
      [styles.mapInsert]: true,
      [this.props.className as string]: this.props.className,
    });
    const insertSectionClassName = classNames({
      [styles.insertSection]: true,
      ["notranslate"]: true,
    });

    let addressText = this.props.location.address;
    if (this.props.location.address2) {
      addressText += ` ${this.props.location.address2}`;
    }
    if (this.props.location.city) {
      addressText += ` ${this.props.location.city}`;
    }
    if (this.props.location.state) {
      addressText += `, ${this.props.location.state}`;
    }
    if (this.props.location.zip) {
      addressText += ` ${this.props.location.zip}`;
    }

    let phone: React.ReactNode = "";
    if (this.props.location && this.props.location.phone) {
      phone = (
        <>
          <FontAwesome prefix={"fas"} name={"fa-phone-alt"} />
          <PhoneNumber number={this.props.location.phone} isLinked={true} />
        </>
      );
    }

    return (
      <div className={mapInsertClassName}>
        {this.props.onClick && (
          <IconButton
            variant={"ghost"}
            className={styles.closeButton}
            onClick={this.props.onClick}
            aria-label={"Close Map Insert"}
          >
            <FontAwesome ariaHidden={true} prefix={"fas"} name={"fa-times"} />
          </IconButton>
        )}
        <Flex direction={"column"} gap={"3"}>
          <div className={styles.logo}>
            <ImageComponent
              src={this.props.location.organization.logo}
              alt={`${this.props.location.organization.title} logo`}
              title={this.props.location.organization.title}
            />
          </div>
          {addressText && (
            <Text asChild size={"2"} weight={"bold"}>
              <ClickableLink
                className={insertSectionClassName}
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(addressText)}`}
              >
                <FontAwesome prefix="fas" name={"fa-map-marker-alt"} />
                <address>{addressText}</address>
              </ClickableLink>
            </Text>
          )}
          {phone && (
            <Text
              as={"div"}
              size={"2"}
              weight={"bold"}
              className={insertSectionClassName}
            >
              {phone}
            </Text>
          )}
        </Flex>
      </div>
    );
  }
}

export default LocationBlockItem;
